<template>
  <div>
    <div class="action-card">

      <h2>File Formatting</h2>
        <hr/>
      <div class="upload_icons">
        <p><img class="svg" src="/static/images/sidemenu/dark_pdf.svg">PDF format only</p>
        <p><img class="svg" src="/static/images/sidemenu/dark_thumb.svg">Max filesize: 5mb</p>
        <p><img class="svg" src="/static/images/sidemenu/dark_cards.svg"> 1 or 2 sided card</p>
        <p><img class="svg" src="/static/images/sidemenu/dark_landscape.svg"> Landscape or Portrait</p>
      </div>
    </div>

    <div class="action-card">
      <h2>Need Help?</h2>
      <hr/>
      <p>Can’t get everything to look as you want?</p>
      <ul class="help-links">
        <li>
          Read <a href="/support/artwork" target="_blank">Artwork Prep FAQs</a>
        </li>
        <li>
          Read <a href="/support/fileupload" target="_blank">Upload FAQs</a>
        </li>
        <li>Feel free to
          <a href="mailto:support@brandly.com" target="_blank">Email us</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.upload_icons img {
  height: 2em;
  margin-right:1em;
}
.upload_icons p {
  display: block;
  line-height: 3.5em;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["designId", "isTemplate", "basketLines"]),
    lineItem() {
      return this.basketLines.find(line => line.designId == this.designId);
    },
    checkoutUrl() {
      return "/cart";
    }
  },
  methods: {
    ...mapActions(["setDesignAsTemplate"]),
    async onSetTemplate() {
      await this.setDesignAsTemplate();
      this.$router.push("/dashboard");
    }
  },
  async mounted() {
    console.log("mounted", this);
  }
};

function on() {
  document.getElementById("overlay").style.display = "block";
}

function off() {
  document.getElementById("overlay").style.display = "none";
}
</script>



// WEBPACK FOOTER //
// src/components/pages/upload/SideMenu.vue